import { BlocksIconSend } from 'blocks-nextjs/blocks-web-components/components/icon/icons/send';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSend = createComponent({ react: React, tagName: 'cat-icon-send', elementClass: BlocksIconSend });
